export default __webpack_public_path__ + "media/img-5.accd0dca.png";